<template>
  <v-container class="pa-0">
    <v-row v-if="!fetchApplicationsPending && applications.length > 5">
      <v-col :cols="12" :md="3" :offset-md="9">
        <v-text-field
          append-icon="search"
          :label="$t('texts.search')"
          single-line
          hide-details
          v-model="search"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <v-data-table
          :headers="headers"
          :items="formattedItems"
          :search="search"
          :loading="fetchApplicationsPending"
          must-sort
          :no-data-text="$t('texts.comletedApplicationsTablePlaceholder')"
          :no-results-text="$t('texts.noCompletedApplications')"
          :footer-props="{ itemsPerPageText: $t('texts.rowsPerPage')}"
          :hide-default-footer="applications.length < 5"
          class="elevation-0"
        >
          <template v-slot:item.actions="{ item }">
            <v-tooltip color="info" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon class="mx-0"
                  @click="showPdfDialog({
                    title: `${item.job} - ${item.formattedName}`,
                    pdfLink: item.application_pdf
                  })">
                  <v-icon color="primary">insert_drive_file</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('texts.showApplication') }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.status="{ item }">
            <v-tooltip
              v-if="item.status === 'CONTRACTSIGNED'"
              color="green" top
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="green"
                >
                  check
                </v-icon>
              </template>
              <span>{{ $t('texts.applicationStatus.CONTRACTSIGNED') }}</span>
            </v-tooltip>
            <v-tooltip
              v-else
              color="red" top
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="red"
                >
                  close
                </v-icon>
              </template>
              <span>{{ $t('texts.applicationStatus.REFUSAL') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyApplicationsState, mapActions: mapCompanyApplicationsActions } = createNamespacedHelpers('company/applications');

export default {
  name: 'CompanyApplicationCompleted',
  data() {
    return {
      search: '',
    };
  },
  created() {
    this.fetchApplications({
      companyId: this.selectedCompanyId,
      listType: 'closed',
    });
  },
  computed: {
    ...mapCompanyApplicationsState([
      'fetchApplicationsPending',
      'applications',
    ]),
    headers() {
      const headers = [
        {
          text: this.$i18n.t('texts.applicants'),
          value: 'formattedName',
          align: 'left',
        },
        {
          text: this.$i18n.t('texts.workplace'),
          value: 'job',
          align: 'left',
        },
        {
          text: this.$i18n.t('texts.lastActivity'),
          value: 'formattedUpdatedAtDate',
          align: 'left',
        },
        {
          text: this.$i18n.t('texts.status'),
          value: 'status',
          align: 'right',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'center',
        },
      ];
      return headers;
    },
    formattedItems() {
      if (this.applications.length > 0) {
        return this.applications.map((item) => {
          const formattedName = `${item.employee_first_name} ${item.employee_last_name}`;
          const formattedUpdatedAtDate = this.$options.filters.formatDateShort(item.updated_at);
          const formattedItem = {
            ...item,
            formattedName,
            formattedUpdatedAtDate,
          };
          return formattedItem;
        });
      }
      return [];
    },
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
  },
  methods: {
    ...mapCompanyApplicationsActions([
      'fetchApplications',
    ]),
    showPdfDialog(item) {
      this.$eventBus.$emit('show-pdf-dialog', item);
    },
  },
};
</script>
